import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './FormComponents.scss';

export default function RadioButtonItem({ item, selected, onChange, disabled }) {
  const onButtonClick = (event) => {
    event.preventDefault();

    if (!disabled) {
      onChange(item.value);
    }
  };

  return (
    <a
      href=""
      className={classnames('radio-button', {
        'radio-button--select': selected,
        'radio-button--disable': disabled,
      })}
      onClick={onButtonClick}
    >
      <span className="radio-button__fill">&nbsp;</span>
    </a>
  );
}

RadioButtonItem.defaultProps = {
  onChange: () => {},
  selected: false,
  disabled: false,
};

RadioButtonItem.propTypes = {
  onChange: PropTypes.func,
  item: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};
